// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const OperationscatalogExecutionKind = {
  ArgoWorkflow: 'argo-workflow',
  DbManagerLookup: 'db-manager-lookup',
} as const;
export type OperationscatalogExecutionKind =
  (typeof OperationscatalogExecutionKind)[keyof typeof OperationscatalogExecutionKind];

export function instanceOfOperationscatalogExecutionKind(value: any): boolean {
  for (const key in OperationscatalogExecutionKind) {
    if (
      Object.prototype.hasOwnProperty.call(OperationscatalogExecutionKind, key)
    ) {
      if (
        OperationscatalogExecutionKind[
          key as keyof typeof OperationscatalogExecutionKind
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function OperationscatalogExecutionKindFromJSON(
  json: any,
): OperationscatalogExecutionKind {
  return OperationscatalogExecutionKindFromJSONTyped(json, false);
}

export function OperationscatalogExecutionKindFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationscatalogExecutionKind {
  return json as OperationscatalogExecutionKind;
}

export function OperationscatalogExecutionKindToJSON(
  value?: OperationscatalogExecutionKind | null,
): any {
  return value as any;
}

export function OperationscatalogExecutionKindToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): OperationscatalogExecutionKind {
  return value as OperationscatalogExecutionKind;
}
